document.addEventListener('DOMContentLoaded', () => {

  
  const menuBtn = document.querySelector('.navbar__btn');
  const hamburger = document.querySelector('.navbar__burger');
  const nav = document.querySelector('.navbar');
  const navMenu = document.querySelector('.navbar__items');
  const navItems = document.querySelectorAll('.navbar__item');
  // const votingLink = document.querySelector('.voting-link')
  let showMenu = false;

  menuBtn.addEventListener('click', toggleMenu);
  // votingLink.addEventListener('click', closeMenu);

  function toggleMenu() {
      if(!showMenu) {
          hamburger.classList.add('open');
          // nav.classList.add('open');
          navMenu.classList.add('open');
          navItems.forEach(item => item.classList.add('open'));
          showMenu = true;
      } else {
          hamburger.classList.remove('open');
          // nav.classList.remove('open');
          navMenu.classList.remove('open');
          navItems.forEach(item => item.classList.remove('open'));
          showMenu = false;
      }
  }

  function closeMenu() {
      if(showMenu) {
          hamburger.classList.remove('open');
          // nav.classList.remove('open');
          navMenu.classList.remove('open');
          navItems.forEach(item => item.classList.remove('open'));
          showMenu = false;
      }
  }


});

// Get the navbar
var navbar = document.getElementById("navbar");

jQuery(document).ready(function($) {
  // var generateToc = function() {
  //   var sidebarInfo = $('.toc');
  //   var subtitles = $('h1, h2, h3')
  
  //   for(var i=0; i<subtitles.length; i++) {
  //     subtitles[i].setAttribute('id', `${subtitles[i].textContent.toLowerCase().replace(' ', '-')}`)
  //     sidebarInfo.append(`<a href="'#${subtitles[i].textContent.toLowerCase().replace(' ', '-')}' >${subtitles[i].textContent}</a>`);
  //   }
  // }

  // if($('article').hasClass('post-type-post')) {
  //   var sidebarInfo = $('.toc');
  //   var subtitles = $('h1, h2, h3')
  
  //   for(var i=0; i<subtitles.length; i++) {
  //     subtitles[i].setAttribute('id', `${subtitles[i].textContent.toLowerCase().replace(' ', '-')}`)
  //     sidebarInfo.append(`<a href="'#${subtitles[i].textContent.toLowerCase().replace(' ', '-')}' >${subtitles[i].textContent}</a>`);
  //   }
  // }
  
//   // $(".widget-title").html(function(){
//   //   var text= $(this).text().trim().split(" ");
//   //   var first = text.shift();
//   //   return (text.length > 0 ? "<span class='highlight'>"+ first + "</span> " : first) + text.join(" ");
//   // });

  // $('.paragraph_image').each(function(){
  //   $el = $(this);
  //   var style = $el.attr('style');
  //   $el.attr('style','');
  //   $el.parent().attr('style',style);
  // }); //Moves the inline styles

   //Adds the dynamic captions for migrated posts
  $('.paragraph_image').each(function(){
      let title = this.title;
      $(this).after('<figcaption class="caption">'+ title +'</figcaption>');
  });
});

